import { EVENT } from '@/constants';

const subscribedEvents = [
  EVENT.ACIR_SEARCH_BUTTON_CLICKED,
  EVENT.ACIR_COURSE_PROFILE_LOADED,
];

// Dynamic import to mitigate chunk size warning at build time
const loadMixpanel = async () => {
  const { default: mixpanel } = await import('mixpanel-browser');
  return mixpanel;
};

const mixpanelService = {
  init: async (token) => {
    if (token) {
      const mp = await loadMixpanel();
      mp.init(token);
    }
  },
  track: async (eventName, eventData = {}) => {
    const mp = await loadMixpanel();
    mp.track(eventName, eventData);
  },
  getSubscribedEvents: () => {
    return subscribedEvents;
  },
};

const logMockCall = (functionName, params) => {
  console.log(['MOCK MIXPANEL CALLED', functionName, params]);
};

const mockMixpanelService = {
  init: (...args) => {
    logMockCall('initialize', args);
  },
  track: (...args) => {
    logMockCall('track', args);
  },
  getSubscribedEvents: () => {
    return subscribedEvents;
  },
};

const getMixpanelService = (analyticsEnabled) => {
    return (analyticsEnabled) ? mixpanelService : mockMixpanelService;
}
export default getMixpanelService
